import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { checkIsSSo, checkIsDeeplink } from '../../utils/utility';
import Spinner from './Spinner';

const NotFoundComponent = (): ReactElement => {
  if (checkIsSSo()) {
    return <Spinner />;
  }
  // Redirect to /google-auth if it's a deeplink, otherwise redirect to "/"
  const redirectPath = checkIsDeeplink() ? '/google-auth' : '/';
  return <Redirect to={redirectPath} />;
};

export default NotFoundComponent;
